<template>
  <div class="init">
    <div class="router-wrap">
      <div class="mainContentBox">
        <!-- 顶部 -->
        <div class="home_banner">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in banner" :key="index">
              <img :src="'https://sanhaopeisong.com'+item.image" alt=""/>
            </van-swipe-item>
          </van-swipe>
          <div class="text">
            <p class="week_name">{{ getDay }}</p>
            <p class="date_time">{{ getNowFormatDate }}</p>
          </div>
        </div>
        <!-- 缴纳方式 -->
        <div class="title">选择缴费方式</div>
        <!-- 表格 -->
        <div class="type_wrap">
          <!-- 上 -->
          <div class="flex_container">
            <div class="flex_pay_item school_item" @click="$router.push('/schoolList')">
              <span class="school_logo"></span>
              <p class="item_title">学校缴费</p>
              <p class="sub-title">School</p>
              <p class="crossing1"></p>
            </div>
          </div>
          <!-- 下 -->
          <div class="other_item">
            <img class="other_logo" :src="IMG_URL+'/images/scool/index/good.png'" alt="" />
            <div class="right_name" @click="btn">
              <p class="other_title">其他缴费</p>
            </div>
          </div>
        </div>
        <div class="more_server">更多服务，即将来袭</div>
      </div>
    </div>
    <div class="beian" @click="goBeian">{{ beian }}</div>
  </div>
</template>

<script>
import { apiHomeBanner, apiConfig, apiGetAuthUrl } from "@/api/api"
import Swiper from 'swiper'
import {Message} from "element-ui";
export default {
  name: "index",
  data() {
    return {
      banner:'',
      beian:''
    }
  },
  beforeCreate() {
  },
  created() {
    apiConfig({version:'1.2.1'}).then(res=>{
      this.beian = res.data.beian;
      document.title = res.data.name;
    });
    apiHomeBanner().then(res=>{
      this.banner = res.data
    })
  },
  computed: {
    getNowFormatDate() {
      var date = new Date();
      // //月
      var month = date.getMonth()+1;
      console.log(month)
      //日
      var day = date.getDate();
      console.log(day)
      //时
      var hh = date.getHours();
      console.log(hh)
      //分
      var mm = date.getMinutes();
      console.log(mm)
      if(mm < 10){
        return '0'+ mm
      }
      let rq = month + "月" + day + '日   ' + hh + ":" + mm;
      console.log(rq)
      return rq;
    },
    getDay(){
      var date = new Date();
      //星期几
      var day = date.getDay();
      if(day == 1){
        return 'Monday'
      }else if(day == 2){
        return 'Tuesday'
      }else if(day == 3){
        return 'Wednesday'
      }else if(day == 4){
        return 'Thursday'
      }else if(day == 5){
        return 'Friday'
      }else if(day == 6){
        return 'Saturday'
      }else if(day == 0){
        return 'Sunday'
      }
      console.log(day)
      // return day
    }
  },
  methods:{
    btn(){
      Message.warning('功能暂未开启～')
    },
    goBeian(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  },
}
</script>

<style scoped lang="scss">
.swiper-container{
  height: 500px;
  width: 100%;
  .swiper-wrapper{
    .swiper-slide{
      width: 100%;
      height: 100%;
      background-color: #42b983;
      text-align: center;
      line-height: 500px;
    }
  }
}
.mainContentBox{
  p{font-weight: 600}
  .home_banner{
    width: 100%;
    height: 37.86667vw;
    text-align: left;
    //background:url(../../../static/images/scool/index/background.png) no-repeat;
    background-size: cover;
    .week_name{
      padding: 10.4vw 0 2.13333vw 6.13333vw;
      font-size: 6.4vw;
      line-height: 8.8vw;
      font-weight: 700;
      color: black;
    }
    .text{
      position: absolute;
      margin-top: -130px;
    }
    .date_time{
      font-size: 3.46667vw;
      color: #949ba5;
      margin-left: 6.13333vw;
    }
  }
  .title{
    font-family:PingFangSC-Medium;
    font-size: 4.26667vw;
    color:#333;
    font-weight:600;
    line-height: 5.86667vw;
    margin:4.8vw 0 5.33333vw 6.13333vw;
  }
  .type_wrap{
    padding: 0 6.13333vw;
    .flex_container{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .school_item{
        width: 48.6%;
        height: 54.33333vw;
        padding-left: 5.33333vw;
        box-sizing: border-box;
        margin-bottom: 2.66667vw;
      }
      .flex_pay_item{
        background: linear-gradient(180deg,#69adff,#3b74ff);
        //box-shadow: 0 0.53333vw 10.66667vw 0 rgb(0 0 0 / 6%);
        border-radius: 6.4vw 2.13333vw 2.13333vw 2.13333vw;
        .school_logo{
          display: block;
          width: 12.8vw;
          height: 12.8vw;
          background: url(../../../static/images/scool/index/scool.png);
          background-size: cover;
          margin: 8vw 0 5.33333vw;
        }
        .item_title{
          font-size: 5.33333vw;
          line-height: 7.46667vw;
          color: #fff;
        }
        .sub-title{
          font-size: 3.46667vw;
          line-height: 4.8vw;
          color: #FFFFFF;
          margin-bottom: 5.33333vw;
        }
        .crossing1{
          opacity: 0.5;
          background: #8dfffc;
          width: 5.33333vw;
          height: 1.6vw;
          border-radius:0.8vw;
        }
      }
    }
    .other_item{
      height: 23.46667vw;
      width: 100%;
      background: #feffff;
      //box-shadow:0 0.53333vw 10.66667vw 0 rgb(0 0 0 / 6%);
      border-radius: 2.13333vw 2.13333vw 5.33333vw 5.33333vw;
      margin-bottom: 2.66667vw;
      display: flex;
      align-items: center;
      .other_logo{
        display: block;
        width: 12.8vw;
        height: 12.8vw;
        margin: 5.33333vw;
      }
      .right_name{
        .other_title{
          font-size: 5.33333vw;
          color: #010f29;
        }
      }
    }
  }
  .more_server{text-align: center}
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
    height: 156px;
  }
  .van-swipe-item img{
    width: 100%;
    height: 100%;
  }
}
.beian{
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%);
}
.beian:focus{
  color: blue;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue